import { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import { BD, SLIDES } from '../data/branchen';

const FAQ_ITEMS = [
  { q: 'Wie lange dauert es bis ich loslegen kann?', a: 'Wirklich nur ein paar Minuten. Du sagst uns was dein Unternehmen macht, wählst eine Stimme aus und legst fest welche Fragen die KI beantworten soll. Dann einfach Nummer weiterleiten – und sie geht ran.' },
  { q: 'Merkt mein Kunde dass er mit einer KI spricht?', a: 'Viele unserer Nutzer sagen dass selbst ihre eigene Familie den Unterschied nicht bemerkt hat. Überzeuge dich selbst – gib deine Nummer oben ein und hör es live.' },
  { q: 'Was passiert wenn jemand etwas Kompliziertes fragt?', a: 'Kein Problem. Die KI merkt wenn sie nicht weiterkommt und leitet den Anruf an dich weiter oder fragt ob sie einen Rückruf vereinbaren soll. Du verpasst nichts.' },
  { q: 'Muss ich meine Telefonnummer wechseln?', a: 'Nein. Deine Nummer bleibt dieselbe. Du leitest sie einfach weiter – für deine Kunden ändert sich gar nichts.' },
  { q: 'Ist FrontUp DSGVO-konform?', a: 'Ja. Unsere Server stehen in Deutschland, alle Daten bleiben in der EU. Wir erfüllen alle DSGVO-Anforderungen.' },
  { q: 'Kann ich auch wieder kündigen wenn es mir nicht gefällt?', a: 'Ja, jederzeit. Kein Vertrag, keine Mindestlaufzeit, keine Strafe. Wenn du nicht zufrieden bist zahlst du einfach nicht weiter.' },
];

function DemoCard() {
  const [phone, setPhone] = useState('');
  const [agb, setAgb] = useState(false);

  function formatPhone(raw) {
    let n = raw.replace(/\s+/g, '').replace(/-/g, '');
    if (n.startsWith('00')) n = '+' + n.slice(2);
    if (n.startsWith('0')) n = '+49' + n.slice(1);
    return n;
  }

  async function startDemo() {
    if (!phone) { alert('Bitte gib deine Telefonnummer ein.'); return; }
    if (!agb) { alert('Bitte stimme den AGB zu.'); return; }
    const btn = document.querySelector('.dc-btn');
    const orig = btn.textContent;
    btn.textContent = 'Verbinde...';
    btn.disabled = true;
    const formattedPhone = formatPhone(phone);
    try {
      const res = await fetch('https://api.vapi.ai/call', {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer 7b8fb417-a2e2-4bd6-a39b-cdeffeea639e',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          phoneNumberId: '41671f09-56cc-4ec5-8fb4-b6d1aedb11a0',
          assistantId: '9173fc0b-0e02-420a-b7c8-bd80926ed3a6',
          customer: { number: formattedPhone }
        })
      });
      const data = await res.json();
      console.log('Vapi Response:', res.status, data);
      if (res.ok) {
        btn.textContent = 'Anruf gestartet! ✓';
        setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 5000);
      } else {
        console.error('Vapi Fehler:', data);
        alert('Fehler: ' + (data?.message || data?.error || JSON.stringify(data)));
        btn.textContent = orig;
        btn.disabled = false;
      }
    } catch(e) {
      console.error('Fetch Fehler:', e);
      btn.textContent = orig;
      btn.disabled = false;
      alert('Verbindung fehlgeschlagen: ' + e.message);
    }
  }

  return (
    <div className="demo-card">
      <div className="dc-live"><div className="dc-live-dot"></div>Live Demo – jetzt verfügbar</div>
      <div className="dc-h">Hör es selbst.</div>
      <p className="dc-p">Gib deine Nummer ein. Unsere KI ruft dich sofort an – genau so klingt sie bei deinen Kunden.</p>
      <div className="dc-field">
        <span className="dc-flag">🇩🇪</span>
        <input
          className="dc-input"
          type="tel"
          placeholder="+49 176 1234567 oder 0531 123456"
          value={phone}
          onChange={e => setPhone(e.target.value)}
        />
      </div>
      <div className="dc-check">
        <input type="checkbox" id="demo-agb" checked={agb} onChange={e => setAgb(e.target.checked)} />
        <label htmlFor="demo-agb">
          Ich stimme den <span style={{textDecoration:'underline',cursor:'pointer'}}>AGB</span> und der <span style={{textDecoration:'underline',cursor:'pointer'}}>Datenschutzerklärung</span> zu. Der Anruf ist kostenlos und unverbindlich.
        </label>
      </div>
      <button className="dc-btn" onClick={startDemo}>Jetzt kostenlos anrufen lassen</button>
      <div className="dc-foot">
        <span className="dc-foot-item">Kostenlos</span>
        <span className="dc-foot-item">Keine Anmeldung</span>
        <span className="dc-foot-item">DSGVO-konform</span>
      </div>
    </div>
  );
}

function BranchenSlideshow({ onBranche }) {
  const [slideOff, setSlideOff] = useState(0);
  const slideshowRef = useRef(null);
  const dragState = useRef({ sx: 0, drag: false, mv: 0 });

  function getCardW() {
    const c = slideshowRef.current?.querySelector('.slide-card');
    return c ? c.offsetWidth + 14 : 374;
  }

  function slideMove(d) {
    setSlideOff(prev => {
      const max = SLIDES.length - 3;
      return Math.max(0, Math.min(prev + d, max));
    });
  }

  useEffect(() => {
    if (slideshowRef.current) {
      slideshowRef.current.style.transition = 'transform .45s cubic-bezier(.4,0,.2,1)';
      slideshowRef.current.style.transform = `translateX(-${slideOff * getCardW()}px)`;
    }
  }, [slideOff]);

  useEffect(() => {
    const wrap = slideshowRef.current?.parentElement;
    if (!wrap) return;

    function onMouseDown(e) {
      dragState.current = { sx: e.clientX, drag: true, mv: 0 };
      if (slideshowRef.current) slideshowRef.current.style.transition = 'none';
    }
    function onMouseMove(e) {
      if (!dragState.current.drag) return;
      dragState.current.mv = e.clientX - dragState.current.sx;
      if (slideshowRef.current) {
        slideshowRef.current.style.transform = `translateX(${-(slideOff * getCardW()) + dragState.current.mv}px)`;
      }
    }
    function onMouseUp() {
      if (!dragState.current.drag) return;
      dragState.current.drag = false;
      if (Math.abs(dragState.current.mv) > 60) slideMove(dragState.current.mv < 0 ? 1 : -1);
      else {
        if (slideshowRef.current) {
          slideshowRef.current.style.transition = 'transform .45s cubic-bezier(.4,0,.2,1)';
          slideshowRef.current.style.transform = `translateX(-${slideOff * getCardW()}px)`;
        }
      }
    }
    function onTouchStart(e) {
      dragState.current = { sx: e.touches[0].clientX, drag: true, mv: 0 };
      if (slideshowRef.current) slideshowRef.current.style.transition = 'none';
    }
    function onTouchMove(e) {
      if (!dragState.current.drag) return;
      dragState.current.mv = e.touches[0].clientX - dragState.current.sx;
      if (slideshowRef.current) {
        slideshowRef.current.style.transform = `translateX(${-(slideOff * getCardW()) + dragState.current.mv}px)`;
      }
    }
    function onTouchEnd() {
      if (!dragState.current.drag) return;
      dragState.current.drag = false;
      if (Math.abs(dragState.current.mv) > 60) slideMove(dragState.current.mv < 0 ? 1 : -1);
      else {
        if (slideshowRef.current) {
          slideshowRef.current.style.transition = 'transform .45s cubic-bezier(.4,0,.2,1)';
          slideshowRef.current.style.transform = `translateX(-${slideOff * getCardW()}px)`;
        }
      }
    }

    wrap.addEventListener('mousedown', onMouseDown);
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
    wrap.addEventListener('touchstart', onTouchStart, { passive: true });
    wrap.addEventListener('touchmove', onTouchMove, { passive: true });
    wrap.addEventListener('touchend', onTouchEnd);

    return () => {
      wrap.removeEventListener('mousedown', onMouseDown);
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
      wrap.removeEventListener('touchstart', onTouchStart);
      wrap.removeEventListener('touchmove', onTouchMove);
      wrap.removeEventListener('touchend', onTouchEnd);
    };
  }, [slideOff]);

  return (
    <div className="slideshow-wrap" style={{padding:'0 40px'}} id="slideshow-wrap">
      <div className="slideshow" ref={slideshowRef}>
        {SLIDES.map(b => (
          <div className="slide-card" key={b.key} onClick={() => onBranche(b.key)}>
            <img className="slide-img" src={b.img} alt={b.name} loading="lazy" />
            <div className="slide-label">
              <div className="slide-name">{b.name}</div>
              <div className="slide-desc">{b.desc}</div>
            </div>
          </div>
        ))}
      </div>
      <button className="slide-arrow-btn slide-prev" onClick={() => slideMove(-1)}>←</button>
      <button className="slide-arrow-btn slide-next" onClick={() => slideMove(1)}>→</button>
    </div>
  );
}

function BranchenGrid({ onBranche }) {
  const [filter, setFilter] = useState('');
  const items = filter
    ? BD.filter(b => b.name.toLowerCase().includes(filter.toLowerCase()) || b.desc.toLowerCase().includes(filter.toLowerCase()))
    : BD;

  return (
    <section className="branchen-grid-sec">
      <div className="branchen-grid-inner">
        <div className="branchen-top-row">
          <h2 style={{fontSize:'clamp(24px,3vw,36px)',fontWeight:800,letterSpacing:'-1px',color:'#111'}}>Alle Branchen</h2>
          <div className="branchen-search">
            <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input
              type="text"
              placeholder="Branche suchen..."
              value={filter}
              onChange={e => setFilter(e.target.value)}
            />
          </div>
        </div>
        <div className="b-grid">
          {items.map(b => (
            <div className="b-card" key={b.key} onClick={() => onBranche(b.key)}>
              <div className="b-icon">{b.icon}</div>
              <div className="b-name">{b.name}</div>
              <div className="b-desc">{b.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function FAQSection() {
  const [openIdx, setOpenIdx] = useState(null);

  return (
    <section className="faq">
      <div className="faq-inner">
        <div style={{textAlign:'center'}}>
          <div style={{fontSize:12,fontWeight:700,letterSpacing:'2px',textTransform:'uppercase',color:'#111',marginBottom:12}}>FAQ</div>
          <h2 style={{fontSize:'clamp(30px,3.5vw,44px)',fontWeight:800,letterSpacing:'-1.5px',color:'#111'}}>Deine Fragen.<br />Ehrliche Antworten.</h2>
        </div>
        <div className="faq-wrap">
          {FAQ_ITEMS.map((item, i) => (
            <div key={i} className={`faq-item${openIdx === i ? ' open' : ''}`}>
              <button className="faq-q" onClick={() => setOpenIdx(openIdx === i ? null : i)}>
                {item.q}
                <div className="faq-toggle">{openIdx === i ? '−' : '+'}</div>
              </button>
              <div className="faq-a">{item.a}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function HomePage() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const id = location.state.scrollTo;
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 80);
      navigate('/', { replace: true, state: {} });
    }
  }, [location.state, navigate]);

  const goToBranche = (key) => navigate('/branche/' + key);
  const scrollTo = (id) => navigate('/', { state: { scrollTo: id } });

  return (
    <>
      <Nav />

      {/* HERO */}
      <section className="hero">
        <div className="hero-wrap">
          <div>
            <div className="hero-pill"><div className="hero-pill-dot"></div>KI-Telefon · Jetzt in Deutschland</div>
            <h1 className="hero-h1">Kein Anruf geht<br />mehr verloren.</h1>
            <p className="hero-p">FrontUp geht für dich ans Telefon – beantwortet Fragen, bucht Termine und erfasst Leads. Automatisch, 24/7, auf Deutsch.</p>
            <div className="hero-btns">
              <button className="btn-hero-p" onClick={() => navigate('/preise')}>Ersparnis berechnen</button>
              <button className="btn-hero-s" onClick={() => navigate('/demo-buchen')}>Demo buchen</button>
            </div>
            <div className="hero-trust">
              <div className="trust-item">
                <svg viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                DSGVO-konform
              </div>
              <div className="trust-item">
                <svg viewBox="0 0 24 24"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
                Server in Deutschland
              </div>
              <div className="trust-item">
                <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                In 1 Min. eingerichtet
              </div>
            </div>
          </div>
          <div id="demo">
            <DemoCard />
          </div>
        </div>
      </section>

      {/* 3 STATS */}
      <div className="stat-strip">
        <div className="stat-strip-inner">
          <div className="stat-item">
            <div className="stat-num">24/7</div>
            <div className="stat-text">Immer erreichbar – auch wenn du schläfst, im Urlaub bist oder gerade beim Kunden.</div>
          </div>
          <div className="stat-item">
            <div className="stat-num">0€</div>
            <div className="stat-text">Kein Personal nötig. FrontUp kostet einen Bruchteil einer menschlichen Telefonkraft.</div>
          </div>
          <div className="stat-item">
            <div className="stat-num">1min</div>
            <div className="stat-text">Einrichtung. Nummer weiterleiten, fertig. Keine IT, kein Techniker, keine Wartezeit.</div>
          </div>
        </div>
      </div>

      {/* EMOTIONALER BLOCK */}
      <section className="emotional">
        <div className="emotional-inner">
          <div>
            <p className="em-quote">„Dein Telefon klingelt. Du bist beim Kunden. FrontUp geht ran."</p>
          </div>
          <div className="em-list">
            <div className="em-item">
              <div className="em-num">01</div>
              <div>
                <div className="em-title">Du bist in der Küche, ein Tisch will reservieren.</div>
                <div className="em-desc">FrontUp geht ran, trägt den Termin ein – du erfährst es per E-Mail.</div>
              </div>
            </div>
            <div className="em-item">
              <div className="em-num">02</div>
              <div>
                <div className="em-title">Du bist auf der Baustelle, ein Neukunde fragt nach einem Angebot.</div>
                <div className="em-desc">FrontUp erfasst Name, Nummer und Anliegen – du rufst zurück wenn du kannst.</div>
              </div>
            </div>
            <div className="em-item">
              <div className="em-num">03</div>
              <div>
                <div className="em-title">Es ist 23 Uhr, ein Patient braucht morgen früh einen Termin.</div>
                <div className="em-desc">FrontUp bucht direkt in den Kalender – ohne dass du aufwachst.</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ANWENDUNGSFÄLLE */}
      <section className="anwendung" id="anwendung">
        <div className="anw-inner">
          <div className="anw-top">
            <div>
              <h2 className="anw-h">Anwendungsfälle</h2>
              <p className="anw-p">Unser KI-Assistent passt sich flexibel deinen Bedürfnissen an. Automatisierte Anrufe die wirklich Sinn machen.</p>
            </div>
            <button className="btn-fp" onClick={() => scrollTo('demo')}>Jetzt testen</button>
          </div>
          <div className="anw-grid">
            <div className="anw-item">
              <div className="anw-icon">
                <svg viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8"/></svg>
                <div className="anw-title">Sekretariat</div>
              </div>
              <div className="anw-desc">Übernimmt alle eingehenden Anrufe und leitet sie bei Bedarf weiter – vollautomatisch.</div>
            </div>
            <div className="anw-item">
              <div className="anw-icon">
                <svg viewBox="0 0 24 24"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>
                <div className="anw-title">Transkription</div>
              </div>
              <div className="anw-desc">Nimmt das Anliegen entgegen, transkribiert es und schickt dir eine Zusammenfassung per E-Mail.</div>
            </div>
            <div className="anw-item">
              <div className="anw-icon">
                <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                <div className="anw-title">Kundenservice</div>
              </div>
              <div className="anw-desc">Rund um die Uhr für deine Kunden da. Du legst genau fest wie sie sich verhält.</div>
            </div>
            <div className="anw-item">
              <div className="anw-icon">
                <svg viewBox="0 0 24 24"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></svg>
                <div className="anw-title">Bestellannahme</div>
              </div>
              <div className="anw-desc">Schneller Service mit automatisierter 24/7-Anfragenbearbeitung. Jede Bestellung erfasst.</div>
            </div>
            <div className="anw-item">
              <div className="anw-icon">
                <svg viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                <div className="anw-title">Terminplanung</div>
              </div>
              <div className="anw-desc">Vereinbart Termine direkt im Gespräch – kompatibel mit Google Calendar, Outlook, cal.com.</div>
            </div>
            <div className="anw-item">
              <div className="anw-icon">
                <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"/><path d="M19.07 4.93a10 10 0 010 14.14M4.93 4.93a10 10 0 000 14.14"/></svg>
                <div className="anw-title">100+ weitere</div>
              </div>
              <div className="anw-desc">
                Von Immobilien bis Gastronomie.{' '}
                <span onClick={() => scrollTo('branchen')} style={{color:'#fff',textDecoration:'underline',cursor:'pointer'}}>Alle Branchen →</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* BRANCHEN SLIDESHOW */}
      <section className="branchen-sec" id="branchen">
        <div className="branchen-inner">
          <div style={{fontSize:12,fontWeight:700,letterSpacing:'2px',textTransform:'uppercase',color:'#111',marginBottom:14}}>Branchen</div>
          <div style={{display:'flex',alignItems:'flex-end',justifyContent:'space-between',flexWrap:'wrap',gap:16}}>
            <h2 style={{fontSize:'clamp(32px,4vw,52px)',fontWeight:800,letterSpacing:'-2px',lineHeight:1.06,color:'#111'}}>Die passende Lösung für<br />jedes Geschäft.</h2>
            <p style={{fontSize:16,color:'#888',lineHeight:1.65,maxWidth:400}}>Egal ob Restaurant, Arztpraxis oder Kanzlei – FrontUp übernimmt dein Telefon vollautomatisch.</p>
          </div>
        </div>
        <BranchenSlideshow onBranche={goToBranche} />
      </section>

      {/* GRÜNDER */}
      <section className="founder">
        <div className="founder-inner">
          <div>
            <div className="f-label">Warum FrontUp</div>
            <h2 className="f-h">Ich habe FrontUp gebaut, weil ich das Problem selbst kenne.</h2>
            <p className="f-p">Unser Familiencafé hat täglich Anrufe verpasst. Reservierungen die nie ankamen. Kunden die einfach woanders hingegangen sind. Dabei war das Problem nicht der Service – wir waren einfach zu beschäftigt um ranzugehen.</p>
            <p className="f-p">FrontUp ist die Lösung die ich damals gebraucht hätte. Kein teures Personal. Keine komplizierte Technik. Einfach jemand der rangeht wenn ich es nicht kann.</p>
            <div className="f-sig">
              <div className="f-avatar">C</div>
              <div>
                <div className="f-sig-name">Canel Sözer</div>
                <div className="f-sig-role">Gründer, FrontUp</div>
              </div>
            </div>
          </div>
          <div className="f-img">
            <img src="https://images.unsplash.com/photo-1559925393-8be0ec4767c8?w=700&h=500&fit=crop&q=85" alt="Café" />
            <div className="f-img-caption">
              <div className="f-cap-title">Das Café meiner Eltern</div>
              <div className="f-cap-text">Seit FrontUp geht kein Anruf mehr verloren – nicht mal nachts um 22 Uhr.</div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <FAQSection />

      {/* FLATPAY SPLIT */}
      <div className="flatpay">
        <div className="fp-left">
          <h2 className="fp-h">Finden Sie heraus, wie viel Sie sparen können.</h2>
          <p className="fp-p">Über 3.000 Unternehmen in Deutschland vertrauen auf FrontUp. Berechne dein persönliches Einsparpotenzial.</p>
          <button className="btn-fp" onClick={() => navigate('/preise')}>Ersparnisse berechnen</button>
        </div>
        <div className="fp-right">
          <img className="fp-img" src="https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=900&h=560&fit=crop&q=85" alt="Café" />
          <div className="fp-overlay">
            <div className="fp-result">Im ersten Jahr mit FrontUp<br />mehr als 2.800€ gespart.</div>
            <div className="fp-company"></div>
          </div>
        </div>
      </div>

      {/* CTA */}
      <section className="cta">
        <div className="cta-inner">
          <h2 className="cta-h">Bereit für deinen ersten KI-Mitarbeiter?</h2>
          <p className="cta-p">Starte heute kostenlos. In 1 Minute eingerichtet. Kein Risiko, keine Kreditkarte.</p>
          <button className="btn-cta" onClick={() => scrollTo('demo')}>Jetzt kostenlos testen</button>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default HomePage;
